"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addActTemplate = addActTemplate;
exports.batchDeleteComment = batchDeleteComment;
exports.deleteComment = deleteComment;
exports.exportComment = exportComment;
exports.listCommentPage = listCommentPage;
exports.queryCommentInfo = queryCommentInfo;
exports.toggleRecommend = toggleRecommend;
exports.updateComment = updateComment;
exports.updateCommentStatus = updateCommentStatus;
exports.uploadCommunityPic = uploadCommunityPic;
exports.uploadPic = uploadPic;
exports.userContentAudit = userContentAudit;
exports.userContentComments = userContentComments;
exports.userContentCommentsAudit = userContentCommentsAudit;
exports.userContentCommentsChild = userContentCommentsChild;
exports.userContentReplyDelete = userContentReplyDelete;
exports.userContentReplyTop = userContentReplyTop;
exports.userProhibitedSpeech = userProhibitedSpeech;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
// 社区评论分页查询
function listCommentPage(query) {
  return (0, _requestAuth.default)({
    url: '/xyCommunityComment/listCommentPage',
    method: 'get',
    params: query
  });
}

// 查询社区评论详情
function queryCommentInfo(id) {
  return (0, _requestAuth.default)({
    url: "/xyCommunityComment/".concat(id),
    method: 'get'
  });
}

// 修改社区评论状态
function updateCommentStatus(id, status) {
  return (0, _requestAuth.default)({
    url: "/xyCommunityComment/updateStatus/".concat(id, "/").concat(status),
    method: 'post'
  });
}

// 删除社区评论
function deleteComment(id) {
  return (0, _requestAuth.default)({
    url: "/xyCommunityComment/delete/".concat(id),
    method: 'delete'
  });
}

// 批量删除社区评论
function batchDeleteComment(ids) {
  return (0, _requestAuth.default)({
    url: '/xyCommunityComment/batchDelete',
    method: 'post',
    data: ids
  });
}

// 推荐/取消推荐社区评论
function toggleRecommend(id, isTj) {
  return (0, _requestAuth.default)({
    url: "/xyCommunityComment/toggleRecommend/".concat(id, "/").concat(isTj),
    method: 'post'
  });
}

// 修改社区评论
function updateComment(data) {
  return (0, _requestAuth.default)({
    url: '/xyCommunityComment',
    method: 'put',
    data: data
  });
}

// 禁言用户
function userProhibitedSpeech(data) {
  return (0, _requestAuth.default)({
    url: '/xyCommunityComment/userProhibitedSpeech',
    method: 'post',
    data: data
  });
}

// 用户内容审核
function userContentAudit(data) {
  return (0, _requestAuth.default)({
    url: '/xyCommunityComment/userContentAudit',
    method: 'post',
    data: data
  });
}

// 导出社区评论数据
function exportComment(query) {
  return (0, _requestAuth.default)({
    url: '/xyCommunityComment/exportComment',
    method: 'get',
    params: query
  });
}

// 查看文章评论
function userContentComments(data) {
  return (0, _requestAuth.default)({
    url: '/xyCommunityComment/userContentComments',
    method: 'post',
    data: data
  });
}

// 查看评论回复
function userContentCommentsChild(data) {
  return (0, _requestAuth.default)({
    url: '/xyCommunityComment/userContentCommentsChild',
    method: 'post',
    data: data
  });
}

// 用户内容审核/广场
function userContentCommentsAudit(commentId, type) {
  return (0, _requestAuth.default)({
    url: '/xyCommunityComment/userContentCommentsAudit',
    method: 'get',
    params: {
      commentId: commentId,
      type: type
    }
  });
}

// 删除评论回复
function userContentReplyDelete(replyId) {
  return (0, _requestAuth.default)({
    url: '/xyCommunityComment/userContentReplyDelete',
    method: 'get',
    params: {
      replyId: replyId
    }
  });
}

// 评论回复置顶
function userContentReplyTop(replyId) {
  return (0, _requestAuth.default)({
    url: '/xyCommunityComment/userContentReplyTop',
    method: 'get',
    params: {
      replyId: replyId
    }
  });
}

// 新增活动模板
function addActTemplate(data) {
  return (0, _requestAuth.default)({
    url: '/xyCommunityComment/addActTemplate',
    method: 'post',
    data: data
  });
}

// 上传图片 (旧接口)
function uploadPic(data) {
  return (0, _requestAuth.default)({
    url: '/xyCommunityComment/uploadPic',
    method: 'post',
    data: data
  });
}

// 上传社区图片 (新接口)
function uploadCommunityPic(file) {
  var formData = new FormData();
  formData.append('file', file);
  return (0, _requestAuth.default)({
    url: '/xyCommunityComment/uploadPic',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}